import { WEEK_DAY_GROUP } from "@/components/calendar";
import { useNewPriceValue, usePriceSuccessValue } from "@/shared/client";
import { MEDIA } from "@/styles/common";
import { Box, Center, Spinner, Td, Th, Tr } from "@chakra-ui/react";
import { CustomTable, CustomTd } from "./priceTable.style";
import { type PriceTableProps } from "./priceTable.type";

export const PriceTable = ({ currentPrices: oldCurrentPrices }: PriceTableProps) => {
    const EMPTY_GROUP = Array.from({ length: 4 });
    const newPriceData = useNewPriceValue();
    const currentPrices = newPriceData?.currentPrices ?? oldCurrentPrices;

    const isPriceSuccessStatus = usePriceSuccessValue();
    const { isTablet } = MEDIA();

    return isPriceSuccessStatus ? (
        <Box w="100%" overflow={isTablet ? "auto" : ""}>
            <CustomTable>
                {EMPTY_GROUP.flatMap((_, idx) => {
                    return (
                        <Tr>
                            {currentPrices.map((currentPrice) => {
                                const { date, isAvailableBook, season, weekdayNumber, price } = currentPrice;
                                const newDate = {
                                    month: date.split("-")[1],
                                    days: date.split("-")[2],
                                    weekDay: WEEK_DAY_GROUP.find((day) => day.weekNum === Number(weekdayNumber)),
                                };

                                return (
                                    <>
                                        {idx === 0 && (
                                            <Th>
                                                {newDate.month}월 {newDate.days}일 ({newDate.weekDay?.weekDay})
                                            </Th>
                                        )}
                                        {idx === 1 && <Td>{season}</Td>}
                                        {idx === 2 && <Td>{Number(price.discount).toLocaleString()}원</Td>}
                                        {idx === 3 && (
                                            <CustomTd isAvailableBook={isAvailableBook}>
                                                {isAvailableBook ? "예약가능" : "예약마감"}
                                            </CustomTd>
                                        )}
                                    </>
                                );
                            })}
                        </Tr>
                    );
                })}
            </CustomTable>
        </Box>
    ) : (
        <Center h={isTablet ? "221px" : "289px"}>
            <Spinner />
        </Center>
    );
};
